export const priceCategoryLabel = (priceCategory: string) => {
  switch (priceCategory) {
    case 'affordable':
      return '$$';
    case 'mid_range':
      return '$$$';
    case 'luxury':
      return '$$$$';
    default:
      return '';
  }
};
